import { HStack, IconButton, Text, Tooltip, useClipboard, useColorModeValue } from '@chakra-ui/react';
import { FaCheck, FaRegCopy } from 'react-icons/fa';

// Já carregada pelo app; até aqui usada só em telas de documento.
const MONO_STACK = '"JetBrains Mono", "SF Mono", Menlo, monospace';

/**
 * Identificador longo — UUID, TxId, código da adquirente.
 *
 * Ninguém lê um desses: copia. Por isso o valor cabe numa linha truncada em vez de quebrar
 * em duas e desalinhar o grid, guarda o conteúdo inteiro no tooltip, e o clique sobre o
 * próprio texto vale como copiar.
 */
export default function CopyableText({ value, label }: { value?: string | null; label?: string }) {
  const { hasCopied, onCopy } = useClipboard(value ?? '');
  const muted = useColorModeValue('gray.500', 'whiteAlpha.600');

  if (!value) return <Text color={muted}>---</Text>;

  return (
    <HStack spacing={1} align="center" maxW="100%">
      <Tooltip label={hasCopied ? 'Copiado' : value} placement="top" hasArrow openDelay={200}>
        <Text fontFamily={MONO_STACK} fontSize="sm" isTruncated cursor="pointer" onClick={onCopy}>
          {value}
        </Text>
      </Tooltip>
      <IconButton
        aria-label={`Copiar ${label ?? 'valor'}`}
        icon={hasCopied ? <FaCheck /> : <FaRegCopy />}
        size="xs"
        variant="ghost"
        color={hasCopied ? 'green.500' : muted}
        onClick={onCopy}
      />
    </HStack>
  );
}
